<div class="modal-dialog" [attr.role]="'document'">
	<div class="modal-content">
		<div style="margin-bottom: 10px;" class="col-xs-offset-6 col-sm-2 col-sm-offset-10">
			<button class="btn btn-default-reverse btn-block btn-sm" data-dismiss="modal" type="button">Chiudi
			</button>
		</div>
		<div *ngIf="petitumRevisioniList.length > 0" class="modal-dialog" role="document">
			<div class="col-sm-12 coldx">
				<h4>Revisioni valori economici</h4>
				<ul style="margin-top: 20px!important;" *ngFor="let petitumRevisione of petitumRevisioniList let i=index" id="controparticollapse"
					class="controparti">
	
					<li class="panel open_lighter">
						<div class="controparte">
							<div>
								<a data-toggle="collapse" href="#subcontroparte{{i}}" aria-expanded="false"
									aria-controls="'subcontroparte'+i" class="collapsed"><span>Apri</span></a>
								<h4 class="titolo col-sm-9">
									<a data-toggle="collapse" href="#subcontroparte{{i}}" aria-expanded="false"
										aria-controls="'subcontroparte'+i" class="collapsed"> Data inizio validit&agrave; {{
										petitumRevisione.dataRevisioneDa | date:'dd/MM/yyyy'}}</a>
									<span style="margin-left: 50px;">Totale: {{calcolaSomma([
										(petitumRevisione?.tipoPetitum?.id == idPetitumQuantificabile &&
										petitumRevisione?.importoPetitum ? '' + petitumRevisione?.importoPetitum : '0'),
										(petitumRevisione?.tipoPetitum?.id == idPetitumQuantificabile &&
										petitumRevisione?.interessiPetitum ? '' + petitumRevisione?.interessiPetitum : '0'),
										(petitumRevisione?.maggiorDannoCalcolato ? '' + petitumRevisione?.maggiorDannoCalcolato : '0'),
										(petitumRevisione?.rivalutazioneCalcolata && !recuperoCrediti ? '' + petitumRevisione?.rivalutazioneCalcolata : '0'),
										(petitumRevisione?.compensi ? '' + petitumRevisione?.compensi : '0'),
										(petitumRevisione?.spese ? '' + petitumRevisione?.spese : '0'),
										(petitumRevisione?.interessiCalcolatiSpeseLegali && recuperoCrediti ? '' +
										petitumRevisione?.interessiCalcolatiSpeseLegali : '0'),
										(petitumRevisione?.altro ? '' + petitumRevisione?.altro : '0')])}} &euro;</span>
								</h4>
							</div>
						</div>
						<ul class="subcontroparte collapse" id="subcontroparte{{i}}" aria-expanded="false"
							style="height: 40px;margin-top: 20px!important;">
							<li>
								<div style="border: 1px solid #ccc; margin: 15px 5px;">
									<p style="background-color: #f0f0f0; padding: 5px;">Revisione valori economici</p>
	
									<!-- RECUPERO CREDITI: SI -->
									<div class="row" style="padding: 5px;" *ngIf="recuperoCrediti">
										<p class="col-sm-4 matricola">
											Importo petitum: <strong>{{petitumRevisione.importoPetitum | euro}}
												&euro;</strong>
										</p>
										<p class="col-sm-4 matricola">
											Interessi: <strong>{{petitumRevisione.interessiPetitum | euro}} &euro;</strong>
										</p>
										<p class="col-sm-4 matricola">
											Maggior danno: <strong>{{petitumRevisione.maggiorDannoCalcolato | euro}}
												&euro;</strong>
										</p>
										<p class="col-sm-4 matricola">
											Spese legali: <strong>{{petitumRevisione.spese | euro}} &euro;</strong>
										</p>
										<p class="col-sm-4 matricola">
											Interessi spese legali: <strong>{{petitumRevisione.interessiCalcolatiSpeseLegali | euro}}
												&euro;</strong>
										</p>
										<p class="col-sm-4 matricola">
											Importo pattuito: <strong>{{petitumRevisione.altro | euro}} &euro;</strong>
										</p>
									</div>
	
									<!-- RECUPERO CREDITI: NO -->
									<div class="row" style="padding: 5px;" *ngIf="!recuperoCrediti">
										<p class="col-sm-4 matricola">
											Importo: <strong>{{petitumRevisione.importoPetitum | euro}} &euro;</strong>
										</p>
										<p class="col-sm-4 matricola">
											Interessi: <strong>{{petitumRevisione.interessiPetitum | euro}} &euro;</strong>
										</p>
										<p class="col-sm-4 matricola">
											Rivalutazione: <strong>{{petitumRevisione.rivalutazioneCalcolata | euro}} &euro;</strong>
										</p>
									</div>
									<div class="row" style="padding: 5px;">
										<p class="col-sm-4 matricola">
										  Maggior danno: <strong>{{petitumRevisione.maggiorDannoCalcolato | euro}}
										  &euro;</strong>
										</p>
									  </div>
	
								</div>
								<div class="row">
									<div class="bloccodati col-sm-12">
										<p class="col-sm-12">
											<label for="mot_revisione">Motivo aggiornamento</label> <input disabled=""
												id="mot_revisione" name="mot_revisione" type="text"
												[value]="petitumRevisione.motivoRevisione">
										</p>
									</div>
								</div>
							</li>
						</ul>
				</ul>
			</div>
		</div>
	</div>
</div>








<!-- <div class="modal-content">
	<p class="col-sm-2 col-sm-offset-10">
		<button class="btn btn-default-reverse btn-block btn-sm"
			data-dismiss="modal" type="button">Chiudi</button>
	</p>
	<div *ngIf="petitumRevisioniList.length > 0" class="modal-dialog"
		role="document">
		<div class="col-sm-12 coldx">
			<h4>Revisioni valori economici</h4>
			<ul *ngFor="let petitumRevisione of petitumRevisioniList let i=index"
				id="controparticollapse" class="controparti">

				<li class="panel open_lighter">
					<div class="controparte">
						<div>
							<a data-toggle="collapse" href="#subcontroparte{{i}}"
								aria-expanded="false" aria-controls="'subcontroparte'+i"
								class="collapsed"><span>Apri</span></a>
							<h4 class="titolo col-sm-3">
								<a data-toggle="collapse" href="#subcontroparte{{i}}"
									aria-expanded="false" aria-controls="'subcontroparte'+i"
									class="collapsed"> Data inizio validit&agrave; {{
									petitumRevisione.dataRevisioneDa | date:'dd/MM/yyyy'}}</a>
							</h4>
							<p class="col-sm-3 matricola">
								Importo: <strong>{{petitumRevisione.importoPetitum |
									euro}} &euro;</strong>
							</p>
							<p class="col-sm-3 matricola">
								Interessi: <strong>{{ petitumRevisione.interessiPetitum
									| euro}} &euro;</strong>
							</p>
							<p class="col-sm-3 matricola">
								Compensi: <strong>{{petitumRevisione.compensi | euro}}
									&euro;</strong>
							</p>
							<p class="col-sm-3 matricola">
								Spese: <strong>{{petitumRevisione.spese | euro}} &euro;</strong>
							</p>
							<p class="col-sm-3 matricola">
								Altro: <strong>{{petitumRevisione.altro
									| euro}} &euro;</strong>
							</p>
						</div>
					</div>
					<ul class="subcontroparte collapse" id="subcontroparte{{i}}"
						aria-expanded="false" style="height: 40px;">
						<li>
							<div class="row_container_fieldset mtop20">
								<fieldset class="form-group">
									<legend>Revisione accantonamento</legend>
									<div class="row">
										<div class="bloccodati col-sm-12">
											<p class="col-sm-2">
												<label for="grado_rischio">Grado di rischio</label> <input
													disabled="" name="grado_rischio" type="text"
													[value]="petitumRevisione.gradoRischio?.label">
											</p>
											<p class="col-sm-2">
												<label for="perc_soccombenza">% di soccombenza</label> <input
													disabled="" name="perc_soccombenza" type="text"
													[value]="(petitumRevisione.percentualeSoccombenza ? petitumRevisione.percentualeSoccombenza : 0 )+' %'">
											</p>
											<p class="col-sm-3">
												<label for="acc_petitum">Petitum</label> <input disabled=""
													name="acc_petitum" type="text"
													[value]="(petitumRevisione.accantonamentoPetitum | euro) +' &euro;'">
											</p>
											<p class="col-sm-3">
												<label for="acc_interessi">Interessi</label> <input
													disabled="" name="acc_interessi" type="text"
													[value]="(petitumRevisione.accantonamentoInteressi | euro) +' &euro;'">
											</p>
							
											<p class="col-sm-2">
												<label for="acc_costi">Compensi e Spese</label> <input
													disabled="" name="acc_costi" type="text"
													[value]="(petitumRevisione.accantonamentoCompensiSpeseTotale | euro) +' &euro;'">
											</p>
										</div>
									</div>
								</fieldset>
							</div>
							<div class="row">
								<div class="bloccodati col-sm-12">
									<p class="col-sm-12">
										<label for="mot_revisione">Motivo revisione</label> <input
											disabled="" name="mot_revisione" type="text"
											[value]="petitumRevisione.motivoRevisione">
									</p>
								</div>
							</div>
						</li>
					</ul> 

			</ul>
		</div>
	</div>
</div> -->